import { User } from "types";

import AddDatasetIcon from "assets/icons/AddDatasetIcon";
import styles from "./style.module.scss";
import { useEffect } from "react";
import { useHandleDatasetCreation } from "hooks/useHandleDatasetCreation";

type AddDatasetCardTypes = {
  isContentLoading: boolean;
  user: User | null;
};

const AddDatasetCard = ({ isContentLoading, user }: AddDatasetCardTypes) => {
  const { handleDatasetCreation: handleButtonClick } =
    useHandleDatasetCreation();

  useEffect(() => {
    const datasetCreationEnabled = (
      process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || ""
    )
      .trim()
      .replace(/"/g, "");
    if (datasetCreationEnabled) {
      console.log(
        "On-Prem Dataset Creation Variable is Configured:",
        datasetCreationEnabled,
      );
    } else {
      console.log(
        "On-Prem Dataset Creation Variable is NOT Configured:",
        datasetCreationEnabled,
      );
    }
  }, []);

  return (
    <div
      className={isContentLoading ? "d-none" : styles.addDatasetWrapper}
      onClick={handleButtonClick}
    >
      <div className={styles.addDatasetIcon}>
        <AddDatasetIcon />
      </div>
      <span className={styles.addDatasetText}>Add a new Dataset</span>
    </div>
  );
};

export default AddDatasetCard;
